function getLocaleDateString(): string {
    const formats: Record<string, string> = {
        "af-ZA": "yyyy/MM/dd HH:mm",
        "am-ET": "d/M/yyyy HH:mm",
        "ar-AE": "dd/MM/yyyy HH:mm",
        "ar-BH": "dd/MM/yyyy HH:mm",
        "ar-DZ": "dd-MM-yyyy HH:mm",
        "ar-EG": "dd/MM/yyyy HH:mm",
        "ar-IQ": "dd/MM/yyyy HH:mm",
        "ar-JO": "dd/MM/yyyy HH:mm",
        "ar-KW": "dd/MM/yyyy HH:mm",
        "ar-LB": "dd/MM/yyyy HH:mm",
        "ar-LY": "dd/MM/yyyy HH:mm",
        "ar-MA": "dd-MM-yyyy HH:mm",
        "ar-OM": "dd/MM/yyyy HH:mm",
        "ar-QA": "dd/MM/yyyy HH:mm",
        "ar-SA": "dd/MM/yy HH:mm",
        "ar-SY": "dd/MM/yyyy HH:mm",
        "ar-TN": "dd-MM-yyyy HH:mm",
        "ar-YE": "dd/MM/yyyy HH:mm",
        "arn-CL": "dd-MM-yyyy HH:mm",
        "as-IN": "dd-MM-yyyy HH:mm",
        "az-Cyrl-AZ": "dd.MM.yyyy HH:mm",
        "az-Latn-AZ": "dd.MM.yyyy HH:mm",
        "ba-RU": "dd.MM.yy HH:mm",
        "be-BY": "dd.MM.yyyy HH:mm",
        "bg-BG": "dd.M.yyyy HH:mm",
        "bn-BD": "dd-MM-yy HH:mm",
        "bn-IN": "dd-MM-yy HH:mm",
        "bo-CN": "yyyy/M/d HH:mm",
        "br-FR": "dd/MM/yyyy HH:mm",
        "bs-Cyrl-BA": "d.M.yyyy HH:mm",
        "bs-Latn-BA": "d.M.yyyy HH:mm",
        "ca-ES": "dd/MM/yyyy HH:mm",
        "co-FR": "dd/MM/yyyy HH:mm",
        "cs-CZ": "d.M.yyyy HH:mm",
        "cy-GB": "dd/MM/yyyy HH:mm",
        "da-DK": "dd-MM-yyyy HH:mm",
        "de-AT": "dd.MM.yyyy HH:mm",
        "de-CH": "dd.MM.yyyy HH:mm",
        "de-DE": "dd.MM.yyyy HH:mm",
        "de-LI": "dd.MM.yyyy HH:mm",
        "de-LU": "dd.MM.yyyy HH:mm",
        "dsb-DE": "d. M. yyyy HH:mm",
        "dv-MV": "dd/MM/yy HH:mm",
        "el-GR": "d/M/yyyy HH:mm",
        "en-029": "MM/dd/yyyy HH:mm",
        "en-AU": "d/MM/yyyy HH:mm",
        "en-BZ": "dd/MM/yyyy HH:mm",
        "en-CA": "dd/MM/yyyy HH:mm",
        "en-GB": "dd/MM/yyyy HH:mm",
        "en-IE": "dd/MM/yyyy HH:mm",
        "en-IN": "dd-MM-yyyy HH:mm",
        "en-JM": "dd/MM/yyyy HH:mm",
        "en-MY": "d/M/yyyy HH:mm",
        "en-NZ": "d/MM/yyyy HH:mm",
        "en-PH": "M/d/yyyy HH:mm",
        "en-SG": "d/M/yyyy HH:mm",
        "en-TT": "dd/MM/yyyy HH:mm",
        "en-US": "M/d/yyyy HH:mm",
        "en-ZA": "yyyy/MM/dd HH:mm",
        "en-ZW": "M/d/yyyy HH:mm",
        "es-AR": "dd/MM/yyyy HH:mm",
        "es-BO": "dd/MM/yyyy HH:mm",
        "es-CL": "dd-MM-yyyy HH:mm",
        "es-CO": "dd/MM/yyyy HH:mm",
        "es-CR": "dd/MM/yyyy HH:mm",
        "es-DO": "dd/MM/yyyy HH:mm",
        "es-EC": "dd/MM/yyyy HH:mm",
        "es-ES": "dd/MM/yyyy HH:mm",
        "es-GT": "dd/MM/yyyy HH:mm",
        "es-HN": "dd/MM/yyyy HH:mm",
        "es-MX": "dd/MM/yyyy HH:mm",
        "es-NI": "dd/MM/yyyy HH:mm",
        "es-PA": "MM/dd/yyyy HH:mm",
        "es-PE": "dd/MM/yyyy HH:mm",
        "es-PR": "dd/MM/yyyy HH:mm",
        "es-PY": "dd/MM/yyyy HH:mm",
        "es-SV": "dd/MM/yyyy HH:mm",
        "es-US": "M/d/yyyy HH:mm",
        "es-UY": "dd/MM/yyyy HH:mm",
        "es-VE": "dd/MM/yyyy HH:mm",
        "et-EE": "d.MM.yyyy HH:mm",
        "eu-ES": "yyyy/MM/dd HH:mm",
        "fa-IR": "MM/dd/yyyy HH:mm",
        "fi-FI": "d.M.yyyy HH:mm",
        "fil-PH": "M/d/yyyy HH:mm",
        "fo-FO": "dd-MM-yyyy HH:mm",
        "fr-BE": "d/MM/yyyy HH:mm",
        "fr-CA": "yyyy-MM-dd HH:mm",
        "fr-CH": "dd.MM.yyyy HH:mm",
        "fr-FR": "dd/MM/yyyy HH:mm",
        "fr-LU": "dd/MM/yyyy HH:mm",
        "fr-MC": "dd/MM/yyyy HH:mm",
        "fy-NL": "d-M-yyyy HH:mm",
        "ga-IE": "dd/MM/yyyy HH:mm",
        "gd-GB": "dd/MM/yyyy HH:mm",
        "gl-ES": "dd/MM/yy HH:mm",
        "gsw-FR": "dd/MM/yyyy HH:mm",
        "gu-IN": "dd-MM-yy HH:mm",
        "ha-Latn-NG": "d/M/yyyy HH:mm",
        "he-IL": "dd/MM/yyyy HH:mm",
        "hi-IN": "dd-MM-yyyy HH:mm",
        "hr-BA": "d.M.yyyy. HH:mm",
        "hr-HR": "d.M.yyyy HH:mm",
        "hsb-DE": "d. M. yyyy HH:mm",
        "hu-HU": "yyyy. MM. dd. HH:mm",
        "hy-AM": "dd.MM.yyyy HH:mm",
        "id-ID": "dd/MM/yyyy HH:mm",
        "ig-NG": "d/M/yyyy HH:mm",
        "ii-CN": "yyyy/M/d HH:mm",
        "is-IS": "d.M.yyyy HH:mm",
        "it-CH": "dd.MM.yyyy HH:mm",
        "it-IT": "dd/MM/yyyy HH:mm",
        "iu-Cans-CA": "d/M/yyyy HH:mm",
        "iu-Latn-CA": "d/MM/yyyy HH:mm",
        "ja-JP": "yyyy/MM/dd HH:mm",
        "ka-GE": "dd.MM.yyyy HH:mm",
        "kk-KZ": "dd.MM.yyyy HH:mm",
        "kl-GL": "dd-MM-yyyy HH:mm",
        "km-KH": "yyyy-MM-dd HH:mm",
        "kn-IN": "dd-MM-yy HH:mm",
        "ko-KR": "yyyy. MM. dd HH:mm",
        "kok-IN": "dd-MM-yyyy HH:mm",
        "ky-KG": "dd.MM.yy HH:mm",
        "lb-LU": "dd/MM/yyyy HH:mm",
        "lo-LA": "dd/MM/yyyy HH:mm",
        "lt-LT": "yyyy.MM.dd HH:mm",
        "lv-LV": "yyyy.MM.dd. HH:mm",
        "mi-NZ": "dd/MM/yyyy HH:mm",
        "mk-MK": "dd.MM.yyyy HH:mm",
        "ml-IN": "dd-MM-yy HH:mm",
        "mn-MN": "yy.MM.dd HH:mm",
        "mn-Mong-CN": "yyyy/M/d HH:mm",
        "moh-CA": "M/d/yyyy HH:mm",
        "mr-IN": "dd-MM-yyyy HH:mm",
        "ms-BN": "dd/MM/yyyy HH:mm",
        "ms-MY": "dd/MM/yyyy HH:mm",
        "mt-MT": "dd/MM/yyyy HH:mm",
        "nb-NO": "dd.MM.yyyy HH:mm",
        "ne-NP": "M/d/yyyy HH:mm",
        "nl-BE": "d/MM/yyyy HH:mm",
        "nl-NL": "d-M-yyyy HH:mm",
        "nn-NO": "dd.MM.yyyy HH:mm",
        "nso-ZA": "yyyy/MM/dd HH:mm",
        "oc-FR": "dd/MM/yyyy HH:mm",
        "or-IN": "dd-MM-yy HH:mm",
        "pa-IN": "dd-MM-yy HH:mm",
        "pl-PL": "dd.MM.yyyy HH:mm",
        "prs-AF": "dd/MM/yy HH:mm",
        "ps-AF": "dd/MM/yy HH:mm",
        "pt-BR": "d/M/yyyy HH:mm",
        "pt-PT": "dd-MM-yyyy HH:mm",
        "qut-GT": "dd/MM/yyyy HH:mm",
        "quz-BO": "dd/MM/yyyy HH:mm",
        "quz-EC": "dd/MM/yyyy HH:mm",
        "quz-PE": "dd/MM/yyyy HH:mm",
        "rm-CH": "dd/MM/yyyy HH:mm",
        "ro-RO": "dd.MM.yyyy HH:mm",
        "ru-RU": "dd.MM.yyyy HH:mm",
        "rw-RW": "M/d/yyyy HH:mm",
        "sa-IN": "dd-MM-yyyy HH:mm",
        "sah-RU": "MM.dd.yyyy HH:mm",
        "se-FI": "d.M.yyyy HH:mm",
        "se-NO": "dd.MM.yyyy HH:mm",
        "se-SE": "yyyy-MM-dd HH:mm",
        "si-LK": "yyyy-MM-dd HH:mm",
        "sk-SK": "d. M. yyyy HH:mm",
        "sl-SI": "d.M.yyyy HH:mm",
        "sma-NO": "dd.MM.yyyy HH:mm",
        "sma-SE": "yyyy-MM-dd HH:mm",
        "smj-NO": "dd.MM.yyyy HH:mm",
        "smj-SE": "yyyy-MM-dd HH:mm",
        "smn-FI": "d.M.yyyy HH:mm",
        "sms-FI": "d.M.yyyy HH:mm",
        "sq-AL": "yyyy-MM-dd HH:mm",
        "sr-Cyrl-BA": "d.M.yyyy HH:mm",
        "sr-Cyrl-CS": "d.M.yyyy HH:mm",
        "sr-Cyrl-ME": "d.M.yyyy HH:mm",
        "sr-Cyrl-RS": "d.M.yyyy HH:mm",
        "sr-Latn-BA": "d.M.yyyy HH:mm",
        "sr-Latn-CS": "d.M.yyyy HH:mm",
        "sr-Latn-ME": "d.M.yyyy HH:mm",
        "sr-Latn-RS": "d.M.yyyy HH:mm",
        "sv-FI": "d.M.yyyy HH:mm",
        "sv-SE": "yyyy-MM-dd HH:mm",
        "sw-KE": "M/d/yyyy HH:mm",
        "syr-SY": "dd/MM/yyyy HH:mm",
        "ta-IN": "dd-MM-yyyy HH:mm",
        "te-IN": "dd-MM-yy HH:mm",
        "tg-Cyrl-TJ": "dd.MM.yy HH:mm",
        "th-TH": "d/M/yyyy HH:mm",
        "tk-TM": "dd.MM.yy HH:mm",
        "tn-ZA": "yyyy/MM/dd HH:mm",
        "tr-TR": "dd.MM.yyyy HH:mm",
        "tt-RU": "dd.MM.yyyy HH:mm",
        "tzm-Latn-DZ": "dd-MM-yyyy HH:mm",
        "ug-CN": "yyyy-M-d HH:mm",
        "uk-UA": "dd.MM.yyyy HH:mm",
        "ur-PK": "dd/MM/yyyy HH:mm",
        "uz-Cyrl-UZ": "dd.MM.yyyy HH:mm",
        "uz-Latn-UZ": "dd/MM yyyy HH:mm",
        "vi-VN": "dd/MM/yyyy HH:mm",
        "wo-SN": "dd/MM/yyyy HH:mm",
        "xh-ZA": "yyyy/MM/dd HH:mm",
        "yo-NG": "d/M/yyyy HH:mm",
        "zh-CN": "yyyy/M/d HH:mm",
        "zh-HK": "d/M/yyyy HH:mm",
        "zh-MO": "d/M/yyyy HH:mm",
        "zh-SG": "d/M/yyyy HH:mm",
        "zh-TW": "yyyy/M/d HH:mm",
        "zu-ZA": "yyyy/MM/dd HH:mm",
    };


    return formats[navigator.language] || "dd/MM/yyyy HH:mm";;
}
function GetTimestampAsDateTimeString(timestamp: string): string {
    const date = new Date(timestamp);
    const format = getLocaleDateString();

    const options: object = {
        year: format.includes('yyyy') ? 'numeric' : '2-digit',
        month: format.includes('MM') ? '2-digit' : 'numeric',
        day: format.includes('dd') ? '2-digit' : 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    };

    return new Intl.DateTimeFormat(navigator.language, options).format(date);
}

export { GetTimestampAsDateTimeString };